<template>
  <div class="centered">
    <!-- Show loading spinner if loading -->
    <LoadingComponent v-if="isLoading" />
    <!-- Show convenience fee message -->
    <ConvenienceFeeMessageComponent />
    <div class="row custom-amount-container">
      <div class="cell">
        <label
          v-if="showCreditCardLimitDisclaimer()"
          for="pay-amount"
        >Amount (${{ invoice.remaing_digital_wallet_amount }} limit)</label>
        <label
          v-else
          for="pay-amount"
        >Amount</label>
        <input
          id="pay-amount"
          v-model="customAmount"
          class="input amount-input"
          name="pay-amount"
          type="number"
          @change="customAmountChanged"
        >
        <label
          v-if="showCreditCardLimitDisclaimer()"
          class="amount-disclaimer"
        >Credit Card and digital wallets are limited to $15,000. Balance will be due by Zelle, ACH, or Wire Transfer.</label>
      </div>
    </div>

    <!-- Show apple pay button -->
    <div
      v-show="isLoading === false && !error"
      id="apple-pay-button-container"
      class="apple-pay-button apple-pay-button-black"
    />
    <!-- Show error -->
    <BraintreeErrorMessageComponent
      v-if="error"
      :error="error"
    />
    <!-- End ApplePay component -->
  </div>
</template>
<script>
// import ApiError from '../../../../errors/ApiError.js'
import BraintreeError from '../../../../errors/BraintreeError'
import BraintreeErrorMessageComponent from '../../Shared/BraintreeErrorMessageComponent.vue'
import InvoiceValidateMixin from '@/mixins/InvoiceValidateMixin.js'
import LoadingComponent from '../../Shared/LoadingComponent'
import {COMPANY_LEGAL_NAME} from '../../../../constants'
import ConvenienceFeeMessageComponent from '../../Shared/ConvenienceFeeMessageComponent.vue'
export default {
  name: 'ApplePayComponent',
  components: {
    BraintreeErrorMessageComponent,
    LoadingComponent,
    ConvenienceFeeMessageComponent
  },
  mixins: [InvoiceValidateMixin],
  props: ['braintreeInstance', 'invoice', 'disablePaymentMethod', 'deviceData'],
  data: function () {
    return {
      isLoading: true,
      error: null,
      applePayInstance: null,
      applePaySession: null,
      customAmount: 0,
    }
  },
  computed: {
    amount: function () {
      const balance = this.invoice.invoice_balance
      return balance.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    use_arta () {
      return this.canUseArta(this.invoice)
    },
    inventory_ids: function () {
      let tempInvoice = this.invoice
      let out = []
      if (tempInvoice && typeof tempInvoice.invoice_items === 'undefined') {
        return out
      }
      if (tempInvoice && tempInvoice.invoice_items) {
        for (let i = 0; i < tempInvoice.invoice_items.length; i++) {
          let item = tempInvoice.invoice_items[i]
          if (item.inventory_id > 0) {
            out.push(item.inventory_id)
          }
        }
      }
      return out
    }
  },
  /**
   * This component will not be created if the browser does not support Apple Pay.
   */
  created () {
    this.init()
  },
  methods: {
    /**
     * Init the apple pay button
     */
    init: function () {
      // Create an Apple Pay instance.
      const self = this

      if(this.invoice !== undefined){
        this.customAmount = this.invoice.remaing_digital_wallet_amount ? this.invoice.remaing_digital_wallet_amount.toFixed(2) : 0
      }

      window.braintree.applePay.create({
        client: this.braintreeInstance
      }, function (applePayErr, applePayInstance) {
        if (applePayErr) {
          const exception = new BraintreeError(applePayErr)
          self.error = exception.getMessage()
          self.isLoading = false
          console.error(applePayErr)
          self.disable()
          return
        }
        self.isLoading = false
        self.applePayInstance = applePayInstance
        // Set up your Apple Pay button here
        document.getElementById('apple-pay-button-container').addEventListener('click', self.createApplePaySession.bind(self))
      })
    },
    /**
     * Create an ApplePay session payment request
     */
    createApplePaySession: function () {
      const paymentRequest = this.applePayInstance.createPaymentRequest({
        total: {
          label: COMPANY_LEGAL_NAME,
          amount: this.customAmount
        },
        // We recommend collecting billing address information, at minimum
        // billing postal code, and passing that billing postal code with
        // all Apple Pay transactions as a best practice.
        requiredBillingContactFields: ['postalAddress']
      })

      // https://developer.apple.com/documentation/apple_pay_on_the_web/applepaysession
      const version = 3
      this.applePaySession = new window.ApplePaySession(version, paymentRequest)
      this.applePaySession.onvalidatemerchant = this.onValidateMerchant
      this.applePaySession.onpaymentauthorized = this.onPaymentAuthorized
      this.applePaySession.begin()
    },
    /**
     * Handle the payment authorized response
     */
    onPaymentAuthorized: function (event) {
      // Payment props: shippingContact, billingContact, etc...
      const {payment} = event
      const session = this.applePaySession
      const self = this
      this.applePayInstance.tokenize({
        token: event.payment.token
      }, function (tokenizeErr, payload) {
        if (tokenizeErr) {
          const exception = new BraintreeError(tokenizeErr)
          session.completePayment(window.ApplePaySession.STATUS_FAILURE)
          self.error = exception.getMessage()
          return
        }
        const {nonce} = payload

        const paymentForm = {
          nonce: nonce,
          type: 'apple_pay',
          submitCC: false,
          deviceData: self.deviceData,
          isPartialPayment: self.invoice.invoice_balance == self.customAmount ? false : true,
          amount: self.customAmount,
          savedPaymentMethod: false
        }

        if (payment && payment.billingContact) {
          paymentForm.billingContact = payment.billingContact
        }

        self.$store.dispatch('updatePaymentForm', paymentForm).then(function () {
          // The customer has already authorized the payment,
          // normally at this point we would make active the Complete Payment button
          // but ApplePay is different in that we have to leave open the ApplePay sheet,
          // and close it after we have processed the payment nonce.

          // We will complete payment here and close AppleSheet on response.
          // let apiPayload = {}
          // apiPayload.apiEndpoint = 'shipping'
          // apiPayload.postData = {}
          // apiPayload.postData.action = 'pay_and_ship'
          // apiPayload.postData.inventory_ids = self.inventory_ids
          // apiPayload.postData.paymentType = 'braintree'
          // apiPayload.postData.useArta = self.use_arta
          // apiPayload.postData.paymentMethodNonce = self.paymentFormStore.nonce
          // apiPayload.postData.streetAddress = self.paymentFormStore.streetAddress
          // apiPayload.postData.braintreeType = 'ApplePayCard' // can be PayPalAccount
          // apiPayload.postData.braintreeDeviceData = self.paymentFormStore.deviceData

          // self.$store.dispatch('apiCall', apiPayload)
          //   .then(response => {
          //     if (!response || !response.data || response.data.result !== 'success') {
          //       const exception = new ApiError(new Error('Error processing payment'))
          //       self.onPaymentFailure(exception)
          //       return
          //     }
          //     // After you have transacted with the payload.nonce,
          //     // call 'completePayment' to dismiss the Apple Pay sheet.
               session.completePayment(window.ApplePaySession.STATUS_SUCCESS)
          //   })
          //   .catch(error => {
          //     const exception = new ApiError(error)
          //     self.onPaymentFailure(exception)
          //   })
        })
      })
    },
    /**
     * Handle the payment failure response
     */
    onPaymentFailure: function (error) {
      console.error('Error processing payment', error)
      this.error = 'Something went wrong...'
      // Dismiss the Apple Pay sheet
      this.applePaySession.completePayment(window.ApplePaySession.STATUS_FAILURE)
    },
    /**
     * Handle onValidateMerchant callback
     * Should call applePayInstance.performValidation()
     */
    onValidateMerchant: function (event) {
      const {validationURL} = event
      const session = this.applePaySession
      this.applePayInstance.performValidation({
        validationURL: validationURL,
        displayName: COMPANY_LEGAL_NAME
      }, function (err, merchantSession) {
        if (err) {
          const exception = new BraintreeError(err)
          // You should show an error to the user, e.g. 'Apple Pay failed to load.'
          this.error = exception.getMessage()
          console.error(err)
          return
        }
        session.completeMerchantValidation(merchantSession)
      })
    },
    customAmountChanged: function (event) {
      const current = event.target.value
      const amount = parseFloat(current)
      if(amount > this.invoice.remaing_digital_wallet_amount){
        this.customAmount = this.invoice.remaing_digital_wallet_amount
      }
      else{
        this.customAmount = amount
      }
    },
    /**
     * To force a payment method to be hidden from list.
     */
    disable: function () {
      this.disablePaymentMethod(this.$options.name)
    },
    showCreditCardLimitDisclaimer: function () {
      return this.invoice.invoice_total > 15000
    }
  }
}
</script>
<style scoped>
.apple-pay-button {
  display: inline-block;
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: check-out; /* Use any supported button type. */
  appearance: -webkit-appearance;
}
.apple-pay-button-black {
  -apple-pay-button-style: black;
}
.apple-pay-button-white {
  -apple-pay-button-style: white;
}
.apple-pay-button-white-with-line {
  -apple-pay-button-style: white-outline;
}
.centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

.custom-amount-container {
  max-width: 400px;
  width: 100%;
}

.amount-disclaimer {
  text-align: center;
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  font-size: 0.8em;
}
</style>
